// Pure helpers for the cached RSVP id list (no storage; node-testable).
// Only ids are stored: enough for the "You're in" pill and the RSVP button,
// never the full attendance rows (Profile waits for the live list).

export const RSVP_CACHE_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
export const RSVP_CACHE_MAX_IDS = 500;

// Event ids the viewer is attending, from DataContext userEvents rows.
export function attendingEventIds(userEvents) {
  if (!Array.isArray(userEvents)) return [];
  const ids = userEvents
    .filter((e) => e && e.status === "attending" && typeof e.event_id === "string" && e.event_id)
    .map((e) => e.event_id);
  return [...new Set(ids)];
}

export function buildRsvpSnapshot(uid, userEvents, now = Date.now()) {
  if (!uid || !Array.isArray(userEvents)) return null;
  return { uid, savedAt: now, ids: attendingEventIds(userEvents).slice(0, RSVP_CACHE_MAX_IDS) };
}

// The cached id list for `uid` when fresh, else null.
export function readRsvpSnapshot(snap, uid, now = Date.now(), maxAge = RSVP_CACHE_MAX_AGE_MS) {
  if (!snap || !uid || snap.uid !== uid || !Array.isArray(snap.ids)) return null;
  if (!(now - snap.savedAt >= 0) || now - snap.savedAt > maxAge) return null;
  return snap.ids.filter((id) => typeof id === "string" && id);
}
